import { cn } from '@/lib/utils';

type DivProps = React.HTMLAttributes<HTMLDivElement>;

export default function Bullet({ className, ...props }: DivProps) {
  return (
    <div
      className={cn(
        'py-1 px-2 bg-gray-100 rounded-xs text-sm sm:text-xs',
        className
      )}
      {...props}
    ></div>
  );
}
